<template>
<modal @before-open="beforeOpen" 
      @before-close="handleBeforeClose" 
      name="specification-modal" 
      style="z-index: 1002;">
  <div id="modal-header" class="w-100 px-4 py-2 position-relative"
  style="background-color:#1e7bb7">
    <div class="w-100 d-flex">
      <h4 class="text-white">Տեխնիկական բնութագիր</h4>
    </div>
    <button type="button"
      class="close position-absolute"
      style="right: 1.25rem; top: 30%"
      @click="$modal.hide('specification-modal')" aria-label="Close">
      <span aria-hidden="true" class="text-white">&times;</span>
    </button>
  </div>
  <div id="modal-body" style="overflow-x: auto; height: 80%">
    <div class="row h-100 mx-0">
      <div class="col-12 px-4 py-3">
        <div v-if="!_.isEmpty(selectedSpecification)" class="w-100">
          <p>Բնութագիր</p>
          <p>{{ selectedSpecification.description }}</p>
        </div>
        <div v-else class="w-100 h-100 d-flex justify-content-center align-items-center">
          <h4 class="text-center text-info">
            lorem
          </h4>
        </div>
      </div>
    </div>
  </div>
</modal>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
export default {
  name: 'SpecificationModal',
  data() {
    return {
      selectedSpecification: {},
      specifications: [],
      cpvId: null,
      isCreateScreen: false,
      newSpec: {
        description: {
          hy: '',
          ru: '',
          en: 'ajsdlkjflakj',
        },
      }
    }
  },
  computed: {
    descriptionHyRequired () {
      return this.$v.newSpec.description.hy.$dirty && !this.$v.newSpec.description.hy.required
    },
    descriptionRuRequired () {
      return this.$v.newSpec.description.ru.$dirty && !this.$v.newSpec.description.ru.required
    }
  },
  methods: {
    beforeOpen (event) {
      console.log(event)
      this.selectedSpecification = event.params.specifications
      console.log(this.selectedSpecification)
    },
    getSpecifications() {
      return this.$store.dispatch('cpv/getSpecification', this.cpvId).then(response => {
        this.specifications = response.data.data.specifications
      })
    },
    save() {
      // eslint-disable-next-line no-undef
      if(!_.isEmpty(this.selectedSpecification)) {
        this.$emit('close', {
          cpvId: this.cpvId,
          specificationId: this.selectedSpecification.id
        })
        this.$modal.hide('specification-modal')
      }
    },
    handleBeforeOpen({ params }) {
      this.cpvId = params.cpvId
      this.getSpecifications().then(() => {
        this.selectedSpecification = this.specifications.find(spec => {
          return spec.id === params.specificationsId
        })
      }) 
    },
    handleBeforeClose() {
      this.selectedSpecification = {}
      this.isCreateScreen = false
    }
  },
  validations: {
    newSpec: {
        description: {
          hy: { required },
          ru: { required },
        },
      }
  }
}
</script>

<style scoped>
/deep/ .vm--modal {
    top: 15% !important;
    left: unset !important;
    width: 60% !important;
    height: auto !important;
    margin: auto;
    -webkit-border-radius: .3rem !important;
    -moz-border-radius: .3rem !important;
    border-radius: .3rem !important;
}
</style>
